import angular from "angular";
import moment from "moment";
import { directiveFactory } from "../../angular-core";

export class DateAfterOtherDateValidationDirective implements ng.IDirective {
    static componentName: string = "dateAfterOtherDateValidation";
    static $inject = [];

    require = "ngModel";
    restrict = "A";

    link = function (scope: ng.IScope, element: JQLite, attrs: ng.IAttributes, controller: $TSFixMe) {
        scope.$watch(attrs.otherDate, function () {
            controller.$validate();
        });
        controller.$validators.dateAfterOtherDate = function (modelValue: $TSFixMe, viewValue: $TSFixMe) {
            var value = modelValue || viewValue;

            var otherDate = scope.$eval(attrs.otherDate);
            if (otherDate && value) {
                if (attrs.validCanEqual) {
                    var isValid = moment(value).isSameOrAfter(moment(otherDate));
                    return isValid;
                }

                var isValid = moment(value).isAfter(moment(otherDate));
                return isValid;
            }
            return true;
        };
    };
}

angular
    .module("topline.directives")
    .directive(
        DateAfterOtherDateValidationDirective.componentName,
        directiveFactory(DateAfterOtherDateValidationDirective)
    );
